import './gquebbq/style';
import FormStructure from './gquebbq/form_structure';

export default FormStructure;